module.exports = __webpack_public_path__ + "static/media/Time.32ba3267.svg";